// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"1ae449b9","453":"64aababc","532":"fe56baff","573":"d605a62c","728":"ec615d86"}[chunkId] + ".chunk.js";
};